module.exports = __webpack_public_path__ + "img/lr4.dfdd9a42.png";